import { render } from "./Partnerships.vue?vue&type=template&id=7ab6fcb9"
import script from "./Partnerships.vue?vue&type=script&lang=js"
export * from "./Partnerships.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__